import React from 'react';
import { Input, InputProps } from 'semantic-ui-react';

import { formatearConPuntosCadaTresDigitos, mantenerSoloDigitos } from 'src/utilidades';

export interface DineroInputProps extends InputProps {
    /**
     * Se usará como `value` para el _input_. Siempre será formateado con puntos
     * como separador de miles.
     */
    readonly monto: number;
    /**
     * El _input_ se renderiza con estilo de solo lectura y su contenido no podrá
     * cambiarse por el usuario. La función `alCambiar` no será llamada incluso
     * si ha sido provista.
     */
    readonly soloLectura?: boolean;
    /**
     * Función que será llamada cada vez que el usuario intente cambiar el contenido
     * del _input_. Será llamada con el nuevo monto como único argumento. Si se omite
     * el contenido del _input_ no podrá cambiarse.
     */
    alCambiarMonto?(monto: number): void;
}

export const DineroInput = (props: DineroInputProps) => {
    const { monto, soloLectura, alCambiarMonto: alCambiar, ...otrosProps } = props;

    return (
        <Input
            {...otrosProps}
            label={{ basic: true, content: '$' }}
            labelPosition='left'
            input={<input style={soloLectura ? { backgroundColor: '#f0f0f0' } : undefined} />}
            readOnly={soloLectura}
            value={formatearConPuntosCadaTresDigitos(monto)}
            onChange={(_e, { value }) => {
                if (soloLectura) return;
                if (alCambiar) alCambiar(Number(mantenerSoloDigitos(value)));
            }}
        />
    );
};

export default DineroInput;



// WEBPACK FOOTER //
// ./src/componentes/DineroInput/index.tsx